export const createStoryTemplatePageMessages = {
  // Page header
  pageTitle: 'Create Story Template',
  pageDescription: 'Design a new story template for generating characters',

  // Navigation
  backToTemplates: 'Back to Templates',
  successNavigateMessage: 'Template created! Redirecting to templates...',

  // Success states
  templateCreated: 'Story template created successfully!',
  redirecting: 'Redirecting to templates...',

  // Error states
  createError: 'Failed to create story template',
  unexpectedError: 'An unexpected error occurred. Please try again.',

  // Loading states
  loading: 'Loading...',
  creating: 'Creating template...',

  // Accessibility
  pageAriaLabel: 'Create story template page',
  formContainerAriaLabel: 'Story template creation form container',
} as const;
